import React from 'react'
import {  Popup } from 'semantic-ui-react'

const style = {
    borderRadius: 0,
    opacity: 1,
    padding: '2em',
  }
  
  const Tooltip = ({children,texto}) => (
    <Popup
      trigger={children}
      content={texto}
      style={style}
      inverted
    />
  )
  
  export default Tooltip